import type { KemUserSessionWithRelations } from "@ch/generated";
import type { IKemMessageType } from "@ch/helpers/utils/kem-types";
import storage from "localforage";
import { persistReducer } from "redux-persist";
import KemActionTypes from "./types";

export interface IKemState {
  error?: string;
  messages?: IKemMessageType[];
  responseLanguage?: "english" | "pidgin";
  completedOnboardingTourV1?: boolean;
  kemUserSession?: KemUserSessionWithRelations & {
    subscription_status?: "subscribed" | '"unsubscribed"';
    ic_session_key?: string;
  };
  activeSessionKey?: string;
  activeICSessionKey?: string;
  icCompletionProgress?: number;
  coachCompletionProgress?: number;
  shouldShowKemICStartModal?: boolean;
}

export const INITIAL_STATE = {
  error: "",
  messages: [],
  completedOnboardingTourV1: false,
  kemUserSession: undefined,
  activeSessionKey: undefined,
  activeICSessionKey: undefined,
  icCompletionProgress: 0,
  coachCompletionProgress: 0,
  shouldShowKemICStartModal: true,
};

function kemReducer(
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: IKemState = INITIAL_STATE,
  { type, payload }: { type: KemActionTypes; payload: Partial<IKemState> },
) {
  switch (type) {
    case KemActionTypes.UPDATE_APP_KEM_STATE:
      return {
        ...state,
        ...payload,
      };
    case KemActionTypes.LOGOUT:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
}

const persistConfig = {
  key: "kem",
  storage,
  blacklist: [
    "error",
    "isLoading",
    "loading",
    "shouldShowKemICStartModal",
    "icCompletionProgress",
    "coachCompletionProgress",
  ],
};

export default persistReducer(persistConfig, kemReducer);
